'use strict';

angular.module('PinMeTo.directives').component('pmtEmptyState', {
	bindings: {
		icon: '@',
		message: '<'
	},
	transclude: true,
	templateUrl: 'pmtShared/emptyState/pmtEmptyState.html',
	controller: function () {
		let iconUrls = {
			comments: '/static/pmt-ui/svg/empty-states/Empty_states_Comments.svg',
			connect: '/static/pmt-ui/svg/empty-states/Empty_states_Connect.svg',
			done: '/static/pmt-ui/svg/empty-states/Empty_states_Done.svg',
			insights: '/static/pmt-ui/svg/empty-states/Empty_states_Insights.svg',
			location: '/static/pmt-ui/svg/empty-states/Empty_states_Location.svg',
			posts: '/static/pmt-ui/svg/empty-states/Empty_states_Posts.svg'
		};

		this.$onInit = () => {
			this.iconUrl = iconUrls[this.icon];
		};
	}
});
